import { Layout } from "antd";
import MenuWrapper from "./menu";
const { Sider } = Layout;

const SideBar = ({ activeMenu, handleClickMenu, windowWidth, menuItems }) => {
  return (
    <Sider
      className="hidden sm:block !sticky bg-white sm:shadow-sm rounded-lg top-24 max-h-96"
      theme="light"
      collapsed={(windowWidth < 768 && windowWidth > 640) || windowWidth === 640}
    >
      <MenuWrapper
        className="sidebar-wrapper rounded-lg "
        handleClickMenu={handleClickMenu}
        activeMenu={activeMenu}
        menuItems={menuItems}
        mode="vertical"
        windowWidth={windowWidth}
      />
    </Sider>
  );
};
export default SideBar;
